import { useEffect, useMemo, useState } from "react";
import { getWalletAddress } from "utils/api";
import useActiveWeb3React from "./useActiveWeb3React";

export default function useAccount() {
  const { account } = useActiveWeb3React();
  return useMemo(() => getWalletAddress(account), [account]);
}